export default __webpack_public_path__ + "static/media/4.832ed346.txt";